import styles from "@/styles/Video.module.scss";
import OpenAppButton from "./OpenAppButton";
import AndroidAppDownloadBanner from "./AndroidAppDownloadBanner";
import IOSAppDownloadBanner from "./IOSAppDownloadBanner";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AppKick(_ref) {
  let {
    watch
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.appkick,
    children: [/*#__PURE__*/_jsx("p", {
      className: styles.message,
      children: "\u3053\u306E\u52D5\u753B\u306F\u30B3\u30F3\u30C6\u30F3\u30C4\u4FDD\u8B77\u306E\u305F\u3081\u3001\u30A2\u30D7\u30EA\u304B\u3089\u306E\u307F\u3054\u8996\u8074\u3044\u305F\u3060\u3051\u307E\u3059\u3002"
    }), /*#__PURE__*/_jsx("div", {
      className: styles.app,
      children: /*#__PURE__*/_jsx(OpenAppButton, {
        watch: watch
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles["app-download-banner"],
      children: [/*#__PURE__*/_jsx(IOSAppDownloadBanner, {}), /*#__PURE__*/_jsx(AndroidAppDownloadBanner, {})]
    })]
  });
}